import {
  useLayoutEffect2
} from "./chunk-OROA335X.mjs";

// ../../node_modules/.pnpm/@radix-ui+react-direction@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-direction/dist/index.mjs
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var DirectionContext = React.createContext(void 0);
function useDirection(localDir) {
  const globalDir = React.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}

// ../../node_modules/.pnpm/@radix-ui+react-id@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-id/dist/index.mjs
import * as React2 from "react";
var useReactId = React2[" useId ".trim().toString()] || (() => void 0);
var count = 0;
function useId(deterministicId) {
  const [id, setId] = React2.useState(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId) setId((reactId) => reactId ?? String(count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}

export {
  useDirection,
  useId
};
//# sourceMappingURL=chunk-6YWZW6FB.mjs.map